import { render } from "./SelectTemplates.vue?vue&type=template&id=42d37798&scoped=true"
import script from "./SelectTemplates.vue?vue&type=script&lang=js"
export * from "./SelectTemplates.vue?vue&type=script&lang=js"

import "./SelectTemplates.vue?vue&type=style&index=0&id=42d37798&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d37798"]])

export default __exports__